import { withLazy } from 'app/hocs/withLazy'

export const ProviderDictionary = withLazy(
  () => import('features/Provider/components/ProviderDictionary/ProviderDictionary'),
)
